export default __webpack_public_path__ + "images/67f4d320176d326e446d827299e9c31f.png";